import React, { PropTypes } from 'react';
import { Paper } from 'material-ui';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  openEditDialog as openEditDialogAction,
  saveSupplierInfoChanges as saveSupplierInfoChangesAction,
} from './__storeFiles__/actions';
import injectCss from 'react-jss';
import styles from './styles';
import TermsCriteriaNode from '../contract-activities-products/contract-policies/terms-criteria-node';
import BillingInfoNode from '../contract-activities-products/contract-policies/billing-info-node';
import PoliciesNode from '../contract-activities-products/contract-policies/policies/policies-node';
import CheckinCheckout from '../contract-activities-products/contract-policies/checkinout';

const PolicyNotesTemplate = props => {
  const { doc, openEditDialog, saveSupplierInfoChanges } = props;
  const {
    status,
    supplierInfo,
    billingInformation,
    locationPolicy,
    ...propsForCheckInCheckOut,
  } = doc;
  const editable = status === 'draft';
  return (
    <div>
      <TermsCriteriaNode
        {...supplierInfo}
        editable={editable}
        openAddEditContractDialog={openEditDialog}
        forSupplier
        inMaster
      />
      <PoliciesNode
        locationPolicy={locationPolicy}
        supplierEditable={editable}
        openAddEditContractDialog={openEditDialog}
        deleteLocationPolicy={policyType => () => {
          const confirmed = window.confirm('Are sure you want to delete this policy?');
          if (confirmed)
            saveSupplierInfoChanges({
              contractId: props.contractId,
              doc: { policyType },
              updateType: 'DELETE_LOCATION_POLICY',
            });
        }}
        inMaster
      />
      <CheckinCheckout
        {...propsForCheckInCheckOut}
        supplierEditable={editable}
        openAddEditContractDialog={openEditDialog}
        inMaster
      />
      <BillingInfoNode
        {...billingInformation}
        supplierEditable={editable}
        openAddEditContractDialog={openEditDialog}
        inMaster
      />
    </div>
  );
};

PolicyNotesTemplate.propTypes = {
  doc: PropTypes.object,
  classes: PropTypes.object,
  location: PropTypes.object,
  openEditDialog: PropTypes.func,
  saveSupplierInfoChanges: PropTypes.func,
};

const mapStateToProps = ({
  contracting: {
    masterTemplate: { docs },
  },
}) => {
  return {
    doc: docs[docs.currentId] || {},
  };
};

export default connect(
  mapStateToProps,
  {
    goBack,
    openEditDialog: openEditDialogAction,
    saveSupplierInfoChanges: saveSupplierInfoChangesAction,
  },
)(injectCss(styles)(PolicyNotesTemplate));



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/policyNotes.jsx